import { render, staticRenderFns } from "./RegisterCourseSlidebar.vue?vue&type=template&id=55b567fb"
import script from "./RegisterCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./RegisterCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports